var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRingBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.82971,18.8772V15.4035a5.02364,5.02364,0,0,0-2.97211-4.63159,1.859,1.859,0,1,0-3.7152,0A5.02011,5.02011,0,0,0,7.17029,15.4035v3.4737A1.51635,1.51635,0,0,1,5.6842,20.421H9.89471C9.89471,21.2926,10.83582,22,12,22c1.16211,0,2.10529-.7074,2.10529-1.579H18.3158A1.51587,1.51587,0,0,1,16.82971,18.8772Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.59144,9.90283a.53552.53552,0,0,1-1.07048,0A3.82186,3.82186,0,0,0,14.6405,6.14575a.51849.51849,0,1,1,0-1.03644A4.87573,4.87573,0,0,1,19.59144,9.90283ZM22,9.12551a.53551.53551,0,0,1-1.07047,0,6.19241,6.19241,0,0,0-6.289-6.08907A.51849.51849,0,1,1,14.6405,2,7.24627,7.24627,0,0,1,22,9.12551Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40856,9.90283a.53552.53552,0,0,0,1.07048,0A3.82185,3.82185,0,0,1,9.3595,6.14575a.51849.51849,0,1,0,0-1.03644A4.87573,4.87573,0,0,0,4.40856,9.90283ZM2,9.12551a.53551.53551,0,0,0,1.07047,0,6.19241,6.19241,0,0,1,6.289-6.08907A.51849.51849,0,1,0,9.3595,2,7.24627,7.24627,0,0,0,2,9.12551Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingBell);
export default __webpack_public_path__ + "static/media/ring_bell.a2feed5344f4c7560047b3fadfc21f25.svg";
export { ForwardRef as ReactComponent };